module.exports = __webpack_public_path__ + "fonts/FilsonPro-Medium.21feab9.woff";